/* SteamZap homepage redesign — behavior (no dependencies) */
(function () {
  'use strict';

  var PREVIEW = document.documentElement.getAttribute('data-sz-preview') === 'true';
  var previewCount = 0;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { if (el[key]) return false; el[key] = true; return true; }

  /* Shopify money_format aware formatter ("${{amount}}", "{{amount_with_comma_separator}} €", …) */
  function money(cents, format) {
    format = format || '${{amount}}';
    var n = (cents / 100);
    function fmt(dec, thousands, decimal) {
      var s = n.toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var out;
    if (/amount_no_decimals_with_comma_separator/.test(format)) out = fmt(0, '.', ',');
    else if (/amount_with_comma_separator/.test(format)) out = fmt(2, '.', ',');
    else if (/amount_no_decimals/.test(format)) out = fmt(0, ',', '.');
    else if (/amount_with_space_separator/.test(format)) out = fmt(2, ' ', ',');
    else out = fmt(2, ',', '.');
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* Cart ----------------------------------------------------------------- */
  var Cart = {
    count: function () {
      if (PREVIEW) return Promise.resolve(previewCount);
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (c) { return c.item_count; })
        .catch(function () { return null; });
    },
    add: function (variantId, qty) {
      if (PREVIEW) {
        previewCount += qty;
        return new Promise(function (res) { setTimeout(res, 350); });
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
      }).then(function (r) {
        if (r.ok) return r.json();
        return r.json().catch(function () { return {}; }).then(function (e) {
          throw new Error(e.description || e.message || 'Could not add to bag');
        });
      });
    },
    refresh: function () {
      Cart.count().then(function (n) {
        if (n === null) return;
        $$('[data-sz-cart-count]').forEach(function (el) { el.textContent = n; });
        document.dispatchEvent(new CustomEvent('sz:cart:count', { detail: { count: n } }));
      });
    }
  };

  function updateBuyLabel(form, btn) {
    if (!form) return;
    btn = btn || $('[data-sz-add]', form);
    if (!btn) return;
    var qtyInput = $('[data-sz-qty-input]', form);
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var price = parseInt(btn.getAttribute('data-sz-price') || '0', 10);
    var format = btn.getAttribute('data-sz-money') || '${{amount}}';
    var base = btn.getAttribute('data-sz-label') || 'ADD TO BAG';
    btn.textContent = price ? base + ' · ' + money(price * qty, format) : base;
  }

  function bindAddButtons(root) {
    $$('[data-sz-add]', root).forEach(function (btn) {
      if (!once(btn, '__szBound')) return;
      btn.addEventListener('click', function (e) {
        var id = btn.getAttribute('data-sz-add');
        if (!id) return; /* plain link fallback */
        e.preventDefault();
        var form = btn.closest('[data-sz-buy]');
        var qtyInput = form ? $('[data-sz-qty-input]', form) : null;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var label = btn.textContent;
        var errEl = form ? $('[data-sz-error]', form) : null;
        btn.disabled = true;
        if (errEl) errEl.textContent = '';
        Cart.add(id, qty).then(function () {
          btn.classList.add('is-added');
          btn.textContent = btn.getAttribute('data-sz-added-label') || 'ADDED ✓';
          Cart.refresh();
          document.dispatchEvent(new CustomEvent('sz:cart:added', { detail: { id: id, quantity: qty } }));
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.disabled = false;
            if (form) updateBuyLabel(form, btn); else btn.textContent = label;
          }, 1800);
        }).catch(function (err) {
          btn.disabled = false;
          if (errEl) errEl.textContent = err.message || 'Could not add to bag.';
        });
      });
    });
  }

  function initBuyBoxes() {
    $$('[data-sz-buy]').forEach(function (form) {
      if (!once(form, '__szInit')) return;
      var input = $('[data-sz-qty-input]', form);
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 9;
      function set(v) {
        v = Math.min(max, Math.max(min, v));
        input.value = v;
        updateBuyLabel(form);
      }
      $$('[data-sz-qty-dec]', form).forEach(function (b) { b.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); }); });
      $$('[data-sz-qty-inc]', form).forEach(function (b) { b.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); }); });
      input.addEventListener('change', function () { set(parseInt(input.value, 10) || 1); });
      updateBuyLabel(form);
    });
    bindAddButtons(document);
  }

  /* Header ---------------------------------------------------------------- */
  function initHeader() {
    $$('[data-sz-header]').forEach(function (header) {
      if (!once(header, '__szInit')) return;
      var burger = $('[data-sz-burger]', header);
      if (!burger) return;
      burger.addEventListener('click', function () {
        var open = header.getAttribute('data-open') === 'true';
        header.setAttribute('data-open', open ? 'false' : 'true');
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
      $$('.sz-header__mobile a', header).forEach(function (a) {
        a.addEventListener('click', function () {
          header.setAttribute('data-open', 'false');
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  /* Before/after slider --------------------------------------------------- */
  function initSliders() {
    $$('[data-sz-slider]').forEach(function (box) {
      if (!once(box, '__szInit')) return;
      var handle = $('[data-sz-slider-handle]', box);
      var pos = parseFloat(box.getAttribute('data-sz-start') || '50');
      /* Touch: the box allows vertical page scrolling (touch-action: pan-y). A touch only
         becomes a slider drag once it moves mostly horizontally, or when it starts on the handle. */
      var mode = null, activeId = null, startX = 0, startY = 0;
      function set(p) {
        pos = Math.max(2, Math.min(98, p));
        box.style.setProperty('--pos', pos + '%');
        if (handle) handle.setAttribute('aria-valuenow', Math.round(pos));
      }
      function fromEvent(e) {
        var r = box.getBoundingClientRect();
        set(((e.clientX - r.left) / r.width) * 100);
      }
      function beginDrag(e) {
        mode = 'drag';
        try { box.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        fromEvent(e);
      }
      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        activeId = e.pointerId; startX = e.clientX; startY = e.clientY; mode = null;
        if (e.pointerType === 'mouse' || (handle && handle.contains(e.target))) {
          beginDrag(e);
          e.preventDefault();
        }
      });
      box.addEventListener('pointermove', function (e) {
        if (e.pointerId !== activeId) return;
        if (mode === 'drag') { fromEvent(e); return; }
        if (mode === null) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx > 6 && dx > dy) beginDrag(e);
          else if (dy > 6) mode = 'scroll';
        }
      });
      function stop(e) {
        if (mode === null && e && e.type === 'pointerup' && e.pointerId === activeId) fromEvent(e); /* tap sets position */
        mode = null; activeId = null;
      }
      box.addEventListener('pointerup', stop);
      box.addEventListener('pointercancel', stop);
      box.addEventListener('lostpointercapture', stop);
      if (handle) {
        handle.addEventListener('keydown', function (e) {
          var step = e.shiftKey ? 10 : 2;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { set(pos - step); e.preventDefault(); }
          else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { set(pos + step); e.preventDefault(); }
          else if (e.key === 'Home') { set(2); e.preventDefault(); }
          else if (e.key === 'End') { set(98); e.preventDefault(); }
        });
      }
      set(pos);
    });
  }

  /* Attachment picker ----------------------------------------------------- */
  function initTools() {
    $$('[data-sz-tools]').forEach(function (section) {
      if (!once(section, '__szInit')) return;
      var rows = $$('[data-sz-tool]', section);
      var images = $$('[data-sz-tool-image]', section);
      var tag = $('[data-sz-tool-tag]', section);
      function select(i) {
        rows.forEach(function (r, j) { r.setAttribute('aria-expanded', i === j ? 'true' : 'false'); });
        images.forEach(function (img, j) { img.classList.toggle('is-active', i === j); });
        if (tag) tag.textContent = rows[i].getAttribute('data-sz-tool-name') || '';
      }
      rows.forEach(function (r, i) { r.addEventListener('click', function () { select(i); }); });
      if (rows.length) select(0);
    });
  }

  /* FAQ ------------------------------------------------------------------- */
  function initFaq() {
    $$('[data-sz-faq]').forEach(function (list) {
      if (!once(list, '__szInit')) return;
      var items = $$('[data-sz-faq-item]', list);
      items.forEach(function (item, i) {
        var q = $('[data-sz-faq-q]', item);
        if (!q) return;
        q.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (it) {
            it.classList.remove('is-open');
            var b = $('[data-sz-faq-q]', it); if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
        });
        if (i === 0 && list.getAttribute('data-sz-open-first') !== 'false') {
          item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* Smooth anchor scroll with sticky header offset ------------------------ */
  function initAnchors() {
    if (!once(document, '__szAnchors')) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var header = $('[data-sz-header]');
      var offset = header ? header.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (history.pushState) history.pushState(null, '', '#' + id);
    });
  }

  /* Cart page ------------------------------------------------------------- */
  function initCartPage() {
    $$('[data-sz-cart]').forEach(function (section) {
      if (!once(section, '__szInit')) return;
      var sectionId = section.getAttribute('data-sz-section-id');
      var busy = false;

      function setError(msg) {
        var el = $('[data-sz-cart-error]', section);
        if (el) el.textContent = msg || '';
      }

      function swap(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sz-cart]');
        if (!fresh) { window.location.reload(); return null; }
        section.replaceWith(fresh);
        init(); /* binds the fresh section (it has no __szInit flag yet) */
        return fresh;
      }

      function change(line, quantity) {
        if (busy || PREVIEW) return;
        busy = true;
        section.classList.add('is-loading');
        setError('');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Math.max(0, quantity), sections: sectionId, sections_url: window.location.pathname })
        }).then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        }).then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not update your bag.');
          var count = res.data.item_count;
          if (typeof count === 'number') {
            $$('[data-sz-cart-count]').forEach(function (el) { el.textContent = count; });
            document.dispatchEvent(new CustomEvent('sz:cart:count', { detail: { count: count } }));
          }
          var html = res.data.sections && res.data.sections[sectionId];
          if (html) swap(html); else window.location.reload();
        }).catch(function (err) {
          busy = false;
          section.classList.remove('is-loading');
          var message = err.message || 'Could not update your bag.';
          /* re-sync with the server after a failed change, keep the message visible */
          fetch('/cart?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data && data[sectionId]) {
                var fresh = swap(data[sectionId]);
                var el = fresh ? $('[data-sz-cart-error]', fresh) : null;
                if (el) el.textContent = message;
              } else {
                setError(message);
              }
            })
            .catch(function () { setError(message); });
        });
      }

      $$('[data-sz-qty-input]', section).forEach(function (input) {
        var line = input.getAttribute('data-sz-line');
        var step = parseInt(input.step, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        function current() { return parseInt(input.value, 10) || 0; }
        var wrap = input.closest('.sz-qty');
        var dec = wrap ? $('[data-sz-qty-dec]', wrap) : null;
        var inc = wrap ? $('[data-sz-qty-inc]', wrap) : null;
        if (dec) dec.addEventListener('click', function () { change(line, Math.max(0, current() - step)); });
        if (inc) inc.addEventListener('click', function () { change(line, Math.min(max, current() + step)); });
        input.addEventListener('change', function () { change(line, Math.min(max, Math.max(0, current()))); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
      });

      $$('[data-sz-remove]', section).forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          change(link.getAttribute('data-sz-line'), 0);
        });
      });

      var note = $('[data-sz-cart-note]', section);
      if (note) {
        var timer = null;
        note.addEventListener('input', function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (PREVIEW) return;
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ note: note.value })
            }).catch(function () {});
          }, 600);
        });
      }
    });
  }

  function init() {
    initHeader();
    initSliders();
    initTools();
    initFaq();
    initBuyBoxes();
    initCartPage();
    initAnchors();
    Cart.refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Shopify theme editor: re-init when a section is (re)rendered */
  document.addEventListener('shopify:section:load', function () { init(); });

  window.SteamZap = { cart: Cart, init: init, money: money };
})();
